<template>
    <v-container>
      <v-row class="pa-0 mb-n11">
      <v-col cols="9" class="d-flex flex-row">
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="getSelectedTaxType" label="Tax Type" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="mainCompItem.taxYear" label="Tax Year" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0 mr-2"
        :value="mainCompItem.taxId" label="Tax ID" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0 mr-2" label="Base ID"
      :value="mainCompItem.baseId" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="mainCompItem.ownerId" label="Owner ID" readonly tabindex="-1" />
    </v-col>
    <v-col cols="3">
      <v-text-field class="input-text-size pt-0 pb-0" v-model="mainCompItem.propertyOrParcelId"
        label="Property/Parcel ID" readonly tabindex="-1" />
    </v-col>
    </v-row>
    <CRUDList
      ref="crudList"
      :canAdd="isAjustmentAccessible"
      :addDisabledTooltip="isAjustmentAccessible ? '' : adjustmentCreateForbiddenMsg"
      :canEdit="true"
      :canSave="false"
      :showSelect="false"
      :displayTopPagination="false"
      :hideDefaultFooter="true"
      :disableKeyboardFunc="true"
      :enableFixedHeaders="true"
      :headers="headers"
      :selectedItems="selectedItems"
      :baseCrudKey="baseCrudKey"
      :defaultSortBy="defaultSortBy"
      :createNewItem="newItemDialog"
      :dialogHeaderName="dialogHeaderName"
      tableWrapperDynamicClassname='taxroll-table-wrapper-two'
      tableDynamicHeight='200'
      @activateItem="handleAddOrEdit"
      @emitSelectedItem="emitSelectedItem"
      @loadCRUDList="handleLoadCRUDList"
      @crudDialogClose="crudDialogClose"
    >
    <template v-slot:[`editedItem`]="{}">
        <CommonTaxRollAdjustmentsDialogForm :baseCrudKey="baseCrudKey"
         :disabledPosted="disabledPosted"
         :upsrtTransaction="upsrtTransaction"
         :isSaving="isSaving"
         @deleteAdjustment="handleDeleteAdjustment"
         ref="adjustmentDialog" />
      </template>
      <template v-slot:[`additionalActions`]="{}">
        <AuditDialog
          v-if="getActiveTransID"
          :identifier="getActiveTransID"
          activatorCaption="Audit History"
          activatorCaptionStyle="input-text-size" />
      </template>
      <template v-slot:[`additionalActionsAfterSave`]="{}">
        <v-btn class="input-text-size" text color="blue darken-1" v-if="enableSaveBtn"
        :disabled="isSaving" @click="upsrtTransaction()">Save</v-btn>
      </template>
    </CRUDList>
    <!-- <template>
      {{ itemsGetter.date ? "Date : "+ itemsGetter.date : null}}
      {{ itemsGetter.type ? "Type : "+ itemsGetter.type : null}}
      {{ itemsGetter.taxAmt ? "Tax Amount : "+ itemsGetter.taxAmt : null}}
    </template> -->
    <!-- <v-row dense class="mt-2" v-if="!isItOmitOrSa">
        <v-col cols="4" class="pt-4">
          <v-btn
          color="primary"
            rounded
            dense
            small
          >
          <v-icon class="mr-2"> </v-icon>
          Print Paid By Info List
          </v-btn>
        </v-col>
      </v-row> -->
  </v-container>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations, mapState,
} from 'vuex';
import '../../../../assets/style.css';
import { toIsoDate, toShortDate } from '../../../../util/shared/tmc-global';
import { amountToNumber } from '../../../../util/shared/vue-global';
import { adjustmentCreateForbiddenMsg } from '../../../../store/auth/token';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import { taxCommonPostProcessTrans, taxFeesPostProcessTrans } from '../../common-utils/CommonTaxFunctionalities';
import CommonTaxRollAdjustmentsDialogForm from '../../common-utils/CommonTaxRollAdjustmentsDialogForm.vue';
import { POST_LOAD_COMP_TIMER } from '../../common-utils/constants';
import { AdjustmentsHeader } from '../TaxInquiryUtils/TableHeaders.utils';
import AuditDialog from '../../../common/audit/AuditDialog.vue';

export default {
  name: 'TaxRollAdjustments',
  components: {
    CRUDList,
    CommonTaxRollAdjustmentsDialogForm,
    AuditDialog,
  },
  props: {
    selectedRowItem: {
      type: Object,
      default: () => {},
    },
    taxRollBaseCrudKey: {
      type: String,
      default: 'TaxInquiryDialog',
    },
  },

  data() {
    return {
      baseCrudKey: 'TaxRollAdjustments',
      headers: AdjustmentsHeader,
      disabledPosted: true,
      mainBaseCrudKey: 'TaxInquiryDialog',
      enableSaveBtn: true,
      // Guards against a double-click on Save, or Enter immediately followed by a click, firing
      // upsrtTransaction() twice before the first request returns - the backend collapses that
      // to one adjustment, but used to apply it to the tax record and tax roll summary twice
      // (Cherokee, Asana 2026-09-29).
      isSaving: false,
      dialogHeaderName: 'Tax Roll Adjustment',
      activeTransItem: undefined,
      adjustmentCreateForbiddenMsg,
    };
  },
  computed: {
    ...mapState({
      StoreSelItems: (state) => state.tax.taxInquiryTabs.selectedAdjustments,
      lockedValues: (state) => state.tax.taxRollAdjustments.lockedValues,
      adjustmentsDialogVisible: (state) => state.base.crud.isVisible.TaxRollAdjustments,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
      TaxTypeEnum: (state) => state.enums.TaxTypeEnum,
    }),
    ...mapGetters(['todaysDate']),
    // The plus icon on this tab is manual adjustment entry, which needs Adjustment program
    // access. Editing an existing row stays open to any tax user, and so does every adjustment
    // that another screen creates on the user's behalf (Create Omit / Create SA, and the
    // 'update' audit row behind a tax-record edit) - see the upsertTaxRollAdjustments resolver.
    ...mapGetters('auth/token', ['isAjustmentAccessible']),
    ...mapGetters('base/crud', ['item', 'items', 'criteria', 'isValidFormProp']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    lockedRightItems: {
      get() {
        return this.lockedValues;
      },
      set(value) {
        this.setLockedValues(value);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    mainCompItem: {
      get() {
        return this.item(this.taxRollBaseCrudKey);
      },
      set(value) {
        this.setItem([this.taxRollBaseCrudKey, value]);
      },
    },
    getSelectedTaxType() {
      const selVal = (this.TaxTypeEnum || []).find((ft) => ft.name === this.mainCompItem.taxType);
      if (selVal && selVal.name) return `${selVal.name} - ${selVal.description}`;
      return '';
    },
    itemsGetter() {
      const itemData = this.item(this.baseCrudKey);
      return itemData;
    },
    taxRollItemGetter() {
      const itemData = this.item(this.taxRollBaseCrudKey);
      return itemData;
    },
    itemsGettersForTax() {
      const itemData = this.items(this.taxRollBaseCrudKey);
      return itemData;
    },
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setAdjustments(value);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'type',
          direction: 'desc',
        },
      ];
    },
    getActiveTransID() {
      return this.activeTransItem && this.activeTransItem._id;
    },
  },
  watch: {
    adjustmentsDialogVisible(val) {
      if (val) {
        this.enableSaveBtn = false;
        setTimeout(() => {
          this.enableSaveBtn = true;
        }, 100);
      }
    },
  },
  methods: {
    ...mapMutations('tax/taxInquiryTabs', [
      'setAdjustments',
    ]),
    ...mapMutations('tax/taxRollAdjustments', [
      'setLockedValues',
    ]),
    ...mapActions('tax/taxRollAdjustments', [
      'loadTaxAdjustments',
      'upsertTaxRollAdjustments',
      'adjustmentCertCheck',
      'bulkDeleteAdjustments',
    ]),
    ...mapMutations('base/crud', [
      'setItems',
      'setItem',
      'setIsVisible',
    ]),
    ...mapActions('tax/taxInquires', [
      'upsertTaxInquiryTransaction', 'loadTaxInquires',
    ]),
    ...mapActions('tax/taxFee', [
      'loadTaxRollFeesTable',
    ]),
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    newItemDialog() {
      // setTimeout(() => {
      const taxRollItem = this.taxRollItemGetter;
      const newItem = {
        adjOrUpd: 'ADJUST',
        taxYear: taxRollItem.taxYear || this.latestTaxYear,
        taxId: taxRollItem.taxId,
        posted: true,
        // type: '',
      };
      return newItem;
      // }, 100);
    },
    handleAddOrEdit(item, addOrEdit) {
      this.activeTransItem = item;
      const taxRollItem = this.taxRollItemGetter;
      if (addOrEdit === 'newItem') {
        setTimeout(() => {
          this.$refs.adjustmentDialog.handleNewRecordClick();
          if ((taxRollItem.taxYear !== undefined) && (taxRollItem.taxId !== undefined)) {
            this.$refs.adjustmentDialog.handleTaxRollRecords();
          }
        }, POST_LOAD_COMP_TIMER);
      } else {
        setTimeout(() => this.$refs.adjustmentDialog.handleEditRecordClick(), POST_LOAD_COMP_TIMER);
      }
    },
    crudDialogClose() {
      // this.lockedRightItems = true;
      this.$refs.adjustmentDialog.disabledTaxYearId = false;
      this.$refs.adjustmentDialog.ownerInfo = {};
      this.$refs.adjustmentDialog.afterAdjustment = {};
      this.$refs.adjustmentDialog.totalLevies = 0;
      this.$refs.adjustmentDialog.grossAssessed = 0;
      this.$refs.adjustmentDialog.netAssessed = 0;
      this.$refs.adjustmentDialog.calculatedTaxAmount = 0;
    },
    async handleLoadCRUDList(criteriaArgs = {}) {
      // this.lockedRightItems = true;
      const results = this.taxRollItemGetter;
      const { taxYear, taxId } = results;
      const { baseCrudKey } = this;
      const criteria = { ...this.criteriaState, taxYear, taxId };
      await this.loadTaxAdjustments({
        criteria,
        baseCrudKey,
        criteriaArgs,
      });
    },
    taxPostProcessTrans(items) {
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const penaltyDateValue = toShortDate();
      const updatedItems = taxCommonPostProcessTrans(items,
        this.todaysDate, this.taxSettingItem, penaltyDateValue, formatPidPositions);
      return updatedItems;
    },
    async upsrtTransaction() {
      if (this.isSaving) return;
      const validate = this.$refs.crudList.$refs.crudDialog.validateForm();
      if (!validate) return;

      this.isSaving = true;
      try {
        const { baseCrudKey } = this;
        if (this.isValidFormProp(baseCrudKey).value) {
          const item = this.item(this.baseCrudKey);
          const objItem = { ...item };
          const { disabledPosted } = this.$refs.adjustmentDialog;
          if (disabledPosted) {
            delete objItem.posted;
          } else if (objItem.posted && objItem.posted === 'Y') {
            delete objItem.posted;
          }
          objItem.adjDate = item.adjDate ? toIsoDate(item.adjDate) : null;
          objItem.certDate = item.certDate ? toIsoDate(item.certDate) : null;
          objItem.filedDate = item.filedDate ? toIsoDate(item.filedDate) : null;
          if (objItem.adjOrUpd === 'UPDATE') {
            delete objItem.landVal;
            delete objItem.improvementVal;
            delete objItem.mobileVal;
            delete objItem.penaltyVal;
            delete objItem.totalExemptions;
            delete objItem.taxAmt;
          } else {
            objItem.landVal = amountToNumber(objItem.landVal);
            objItem.improvementVal = amountToNumber(objItem.improvementVal);
            objItem.mobileVal = amountToNumber(objItem.mobileVal);
            objItem.penaltyVal = amountToNumber(objItem.penaltyVal);
            objItem.totalExemptions = amountToNumber(objItem.totalExemptions);
            objItem.taxAmt = amountToNumber(objItem.taxAmt);
          }
          const updatedItem = { ...objItem };
          updatedItem.taxYear = parseInt(updatedItem.taxYear, 10);
          updatedItem.taxId = parseInt(updatedItem.taxId, 10);
          updatedItem.certNumber = parseInt(updatedItem.certNumber, 10);

          const beforeAdjustment = this.$refs.adjustmentDialog.ownerInfo;
          updatedItem.valuesBeforeAdjustment = {
            name: beforeAdjustment.name,
            land: amountToNumber(beforeAdjustment.land),
            improvements: amountToNumber(beforeAdjustment.improvements),
            mobileHome: amountToNumber(beforeAdjustment.mobileHome),
            exemptions: amountToNumber(beforeAdjustment.exemptions),
            totalTax: amountToNumber(beforeAdjustment.totalTax),
            assessorPenalty: amountToNumber(beforeAdjustment.assessorPenalty),
            schoolDistrict: beforeAdjustment.schoolDistrict,
          };

          const { afterAdjustment } = this.$refs.adjustmentDialog;

          updatedItem.valuesAfterAdjustment = {
            land: amountToNumber(afterAdjustment.land),
            improvements: amountToNumber(afterAdjustment.improvements),
            mobileHome: amountToNumber(afterAdjustment.mobileHome),
            exemptions: amountToNumber(afterAdjustment.exemptions),
            totalTax: amountToNumber(afterAdjustment.totalTax),
            assessorPenalty: amountToNumber(afterAdjustment.assessorPenalty),
          };
          if (updatedItem._id === undefined) {
            updatedItem.posted = true;
          } else {
            delete updatedItem.posted;
          }

          // await this.upsertTaxRollAdjustments({
          //   item: updatedItem,
          //   baseCrudKey,
          // });
          // this.$nextTick(() => {
          //   this.selectedItems = [];
          // });
          let resp = { status: false };
          if (!updatedItem._id) {
            resp = await this.adjustmentCertCheck({
              criteria:
         {
           taxYear: parseInt(updatedItem.taxYear, 10),
           taxId: parseInt(updatedItem.taxId, 10),
           certNumber: parseInt(updatedItem.certNumber, 10),
         },
            });
          }
          if (resp.status && !this.$refs.adjustmentDialog.continueSubmit && updatedItem.certNumber) {
            this.$refs.adjustmentDialog.dialogCert = true;
            this.$refs.adjustmentDialog.dialogeMessage = resp.message;
          } else {
            await this.upsertTaxRollAdjustments({
              item: updatedItem,
              baseCrudKey,
            });
            this.$nextTick(() => {
              this.selectedItems = [];
              this.$refs.adjustmentDialog.continueSubmit = false;
              this.setIsVisible([baseCrudKey, false]);
            });
          }

          // to show the updated data in tax-info
          const itemData = this.taxRollItemGetter;
          await this.loadTaxInquires({
            criteria: { _id: itemData._id },
            postProcessTrans: this.taxPostProcessTrans,
          }).then((val) => {
            if ((val || []).length) {
              const itemObj = val[0];
              this.setItem([this.taxRollBaseCrudKey, itemObj]);
              const criteria = { taxYear: itemObj.taxYear, taxId: itemObj.taxId };
              this.loadTaxRollFeesTable({
                criteria,
                baseCrudKey: 'taxRollFeesTable',
                postProcessTrans: this.taxFeesPreProcessTrans,
              });
              this.$emit('loadCRUDList', {}, 'fromTaxInquiryDialog');
            }
          });
        }
      } finally {
        this.isSaving = false;
      }
    },
    taxFeesPreProcessTrans(items) {
      const updatedItems = taxFeesPostProcessTrans(items);
      return updatedItems;
    },
    async handleDeleteAdjustment(item) {
      if (!item || !item._id) {
        return;
      }
      try {
        const { baseCrudKey } = this;
        const upsert = {
          _ids: [item._id],
        };
        await this.bulkDeleteAdjustments({ upsert });

        // Close the dialog
        this.setIsVisible([baseCrudKey, false]);

        // Reload the list
        await this.handleLoadCRUDList();

        // Reload tax inquiry data to refresh the main view
        const itemData = this.taxRollItemGetter;
        await this.loadTaxInquires({
          criteria: { _id: itemData._id },
          postProcessTrans: this.taxPostProcessTrans,
        }).then((val) => {
          if ((val || []).length) {
            const itemObj = val[0];
            this.setItem([this.taxRollBaseCrudKey, itemObj]);
            const criteria = { taxYear: itemObj.taxYear, taxId: itemObj.taxId };
            this.loadTaxRollFeesTable({
              criteria,
              baseCrudKey: 'taxRollFeesTable',
              postProcessTrans: this.taxFeesPreProcessTrans,
            });
            this.$emit('loadCRUDList', {}, 'fromTaxInquiryDialog');
          }
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error deleting adjustment:', error);
      }
    },
  },
};
</script>
